<template>
  <ui-modal
    id="comfirmContainer"
    :show="showExit"
    type="tag"
    :title="confirmOptions?.title"
    :iconType="confirmOptions?.iconType"
    @close="closeModal()"
  >
    <div class="inner-content">
      <span>{{ confirmOptions?.tip }}</span>
    </div>
    <div class="bottom-box">
      <ui-frame-bg class="btn" :colorType="confirmOptions?.cancel?.colorType" @click.native="handleCancel">
        <div class="label-box">
          <span class="label-shadow">{{ confirmOptions?.cancel?.label }}</span>
          <span class="label-text">{{ confirmOptions?.cancel?.label }}</span>
        </div>
      </ui-frame-bg>
      <ui-frame-bg class="btn" :colorType="confirmOptions?.apply?.colorType" @click.native="handleApply">
        <div class="label-box">
          <span class="label-shadow">{{ confirmOptions?.apply?.label }}</span>
          <span class="label-text">{{ confirmOptions?.apply?.label }}</span>
        </div>
      </ui-frame-bg>
    </div>
  </ui-modal>
</template>

<script>
import UiModal from "@/components/ui-modal.vue";
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: { UiModal, UiFrameBg },
  props: {
    options: {
      type: Object,
      default: () => ({
        title: '友情提示',
        tip: '二次确认',
        iconType: 'tip',
        cancel: {
          label: '返回',
          colorType: 'blue'
        },
        apply: {
          label: '退出',
          colorType: 'red'
        }
      })
    }
  },
  data() {
    return {
      showExit: false,
      confirmOptions: {},
      defaultOptions: {
        title: '友情提示',
        tip: '二次确认',
        iconType: 'tip',
        cancel: {
          label: '返回',
          colorType: 'blue'
        },
        apply: {
          label: '退出',
          colorType: 'red'
        }
      }
    }
  },
  watch: {
    options: {
      handler(newVal) {
        this.confirmOptions = { ...this.defaultOptions, ...newVal }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    showModal() {
      this.showExit = true;
    },
    closeModal() {
      this.showExit = false;
    },
    handleCancel() {
      this.closeModal()
      this.$emit('cancel')
    },
    handleApply() {
      this.closeModal()
      this.$emit('apply')
    }
  }
}
</script>

<style lang="scss">
#comfirmContainer {
  .modal__container {
    width: 646px;
    height: 353px;
    margin-left: -0.5 * 646px;
    background-image: $bg_popup_mini;
    .modal__inner {
      .title {
        width: 195px;
        font-weight: 500;
        .bg {
          display: none;
        }
      }
      .modal__body {
        background: none;
      }
    }
  }

  .inner-content {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #333333;
    font-weight: 500;
  }
  .bottom-box {
    height: 106px;
    display: flex;
    justify-content: center;
    .btn {
      width: 266px;
      height: 70px;
      overflow: hidden;
      font-size: 28px;
      font-weight: bold;
      @include boxShadowSet_Btn;
      margin: 0 16px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }

      &.cancel {
        background-position: -282px -202px;
      }
      &.confirm {
        background-position: -282px -293px;
      }
    }
  }
}
</style>